export default __webpack_public_path__ + "static/media/HindiDiwas4.bd3d1288.JPG";